module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAiCAYAAAB4BHhVAAAAAXNSR0IArs4c6QAAAB9JREFUKFNj/P////9Xr14xgICYmBgD46jAaHiQkhwAM93tm2naRp0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/dot-line.png
// module id = Aa7c
// module chunks = 1